import { forwardRef } from "react";
import { DattoCustomerMapping } from "./DattoCustomerMapping";
import { DattoDeviceMapping } from "./DattoDeviceMapping";

export const DattoMainWrapper = forwardRef(
  (
    {
      step,
      onStepChange,
    }: { step: number; onStepChange: (step: number) => void },
    ref,
  ) => {
    switch (step) {
      case 1:
        return <DattoCustomerMapping ref={ref} onStepChange={onStepChange} />;
      case 2:
        return <DattoDeviceMapping ref={ref} onStepChange={onStepChange} />;
      default:
        return <DattoCustomerMapping ref={ref} onStepChange={onStepChange} />;
    }
  },
);
